import { useTranslation } from "react-i18next";
import ListItemText from "@mui/material/ListItemText";
import { FossLibrary } from "../entities/FossLibrary";
import {
  lookUpLicenseType,
  MuiCommercialLicense,
} from "../utils/lookUpLicenseType";
import { Link } from "./Link";

export const hasLicenseType = (library: FossLibrary) =>
  !!library.licenseType && library.licenseType !== "n/a";

const licenseLinkMap = {
  MIT: "https://opensource.org/licenses/MIT",
  "Apache-2.0": "https://www.apache.org/licenses/LICENSE-2.0",
  "BSD-2-Clause": "https://opensource.org/licenses/BSD-2-Clause",
  ISC: "https://spdx.org/licenses/ISC.html",
  [MuiCommercialLicense]: "https://mui.com/legal/mui-x-eula/",
};

const getLicenseLink = (library: FossLibrary) => {
  const lookedUpLicense = lookUpLicenseType(library);

  if (!lookedUpLicense) {
    return null;
  }

  return Object.keys(licenseLinkMap).includes(lookedUpLicense)
    ? licenseLinkMap[lookedUpLicense as keyof typeof licenseLinkMap]
    : null;
};

type LicenseTypeProps = {
  library: FossLibrary;
};

export function LicenseType({ library }: LicenseTypeProps) {
  const { t } = useTranslation();
  const licenseLink = getLicenseLink(library);

  const secondary = licenseLink ? (
    <Link href={licenseLink}>{lookUpLicenseType(library)} </Link>
  ) : (
    lookUpLicenseType(library)
  );

  return (
    <ListItemText
      primary={t("thirdpartylibraries.license")}
      secondary={secondary}
    />
  );
}
